<template>
	<form-field-wrap
		:field-props="fieldProps"
		:is-error="isError"
		:field-value="fieldValue"
		:is-switch="isSwitch"
		:input-focus="inputFocus"
	>
		<input class="form-field__input"
		       :class="[inputClass, (fieldValue || inputFocus) ? 'is-fill' : '']"
		       type="text"
		       autocomplete="off"
		       v-phone-mask
		       v-validate="rules"
		       :data-vv-as="fieldProps.TITLE"
		       data-vv-validate-on="change"
		       ref="inputEl"
		       :placeholder="fieldProps.PLACEHOLDER"
		       :name="fieldProps.CODE"
		       :value="fieldValue"
		       :id="fieldProps.ID ? fieldProps.ID : fieldProps.CODE"
		       :disabled="disable"
		       @input="changeValue"
		       @focus="labelSwitch('focus')"
		       @blur="labelSwitch"/>
	</form-field-wrap>
</template>

<script>
	export default {
		name: "FormFieldPhone",
		watch: {
			value(newValue, oldValue) {
				newValue = Array.isArray(newValue) ? newValue[0] : newValue;
				this.inputValue = this.prepareVal(newValue);

				/**
				 * Вызовем вручную событие изменения значения для автомаски значения
				 */
				if (newValue !== this.inputValue) {
					let event;
					if (typeof (Event) === "function") {
						event = new Event("input");
					} else {
						event = document.createEvent("Event");
						event.initEvent("input", true, true);
					}

					this.$refs.inputEl.dispatchEvent(event);
				}
			},
		},
		created: function () {
			this.inputValue = this.prepareVal(Array.isArray(this.value) ? this.value[0] : this.value);
		},
		computed: {
			rules() {
				let arRules = {};

				if (this.fieldProps.REQUIRED == "Y") {
					arRules['required'] = true;
				}
				arRules['regex'] = '(\\+7)?([- ()+]?\\d[- ()+]?){11}';

				return arRules;
			},
		},
		methods: {
			/**
			 * Дополнение значения "+", если отсутствует. Нужно, так как v-mask обрабатвает "7 123 456 78-90" как "+7 (712) 345 67-89"
			 *
			 * @param value
			 */
			prepareVal(value) {
				if (!value) {
					return value;
				}

				let clearValue = value.replace(/[^0-9+]+/g, "");

				if (clearValue.length !== 11 || clearValue.charAt(0) !== "7") {
					return value;
				}

				return "+" + value;
			}
		}
	}
</script>
